var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9434 4.0458H46.112L30.4506 21.9457L48.875 46.3035H34.4489L23.1498 31.5306L10.2211 46.3035H3.04817L19.7995 27.1575L2.125 4.0458H16.9174L27.1307 17.5488L38.9434 4.0458ZM36.4274 42.0127H40.3996L14.759 8.11121H10.4964L36.4274 42.0127Z",
    fill: "#C8B690"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.a23ba5c59c933cfd17c9953ddf619aa3.svg";
export { ForwardRef as ReactComponent };